<template>
    <div class="table-wrapper">
        <p :class="{ 'fz-20': inModal }" class="table-title">Актуальные уведомления на {{dateParser(actualDate)}}</p>
        <table :class="{ 'tile-table': !inModal, 'modal-table': inModal }" class="table">
            <thead>
                <tr>
                    <th class="ws-nw">№ п/п</th>
                    <th class="ws-nw">№ уведомления</th>
                    <th>Дата</th>
                    <th>Залогодержатель</th>
                    <th v-if="inModal">Номер имущества</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(z, i) in list" :key="i">
                    <td class="ws-nw">{{pagination.min_row_on_page + i}}</td>
                    <td>{{z.notification_number ? z.notification_number : '—'}}</td>
                    <td class="ws-nw">{{z.date_reg ? dateParser(z.date_reg) : '—'}}</td>
                    <td :class="{ 'w-30': inModal }">{{z.pledgees ? z.pledgees : '—'}}</td>
                    <td class="w-30" v-if="inModal">{{z.property_number ? z.property_number : '—'}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        actualDate: String,
        list: Array,
        inModal: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        pagination() { return this.$store.state?.card?.zalogLeasing?.zalog?.pagination }
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.table-title
    font-size: 16px
    font-weight: 600
    border-bottom: 1px solid
    line-height: 18px
    margin: 0

.table
    // @include lic-table
    td, th
        padding: 5px 8px !important
        font-size: 16px !important
    .ws-nw
        width: 1%
        white-space: nowrap
    
.tile-table
    td
        font-size: 13px !important
        text-align: left !important
.modal-table
    td
        border-bottom: 1px solid #ddd !important
        text-align: left !important
    .w-40
        width: 40% !important
    .w-30
        width: 30% !important
        word-break: break-word
.fz-20
    font-size: 20px
</style>